import { notification } from "antd";
import { defineMessages, IntlShape } from "react-intl";

interface IProps {
    intl: IntlShape;
    reset: () => void;
}

const MESSAGES = defineMessages({
    blockAlreadyScheduledMessage: {
        id: "block_already_scheduled_notification.message",
        defaultMessage: "Tank blokkeren mislukt"
    },
    blockAlreadyScheduledDescription: {
        id: "block_already_scheduled_notification.description",
        defaultMessage: "Deze tank is reeds geblokkeerd in het gekozen timeframe. Gelieve een ander tijdstip te kiezen."
    }
});

export const BlockAlreadyScheduledNotification = (props: IProps) => {
    notification.error({
        message: props.intl.formatMessage(MESSAGES.blockAlreadyScheduledMessage),
        description: props.intl.formatMessage(MESSAGES.blockAlreadyScheduledDescription),
        onClose: () => props.reset(),
        placement: "bottomRight"
    });
    return null;
};
